module.exports = __webpack_public_path__ + "static/scale-model-of-molly-brown-house-museum-in-denver-colorado-5ee0ad34382fd43f2d34e5aa28ddb209.png";